import { render } from "./EditService.vue?vue&type=template&id=134cb19c&ts=true"
import script from "./EditService.vue?vue&type=script&lang=ts"
export * from "./EditService.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__